<template>
  <div class="container-fluid o-card" id="tks-calculating-result">
    <h4>
      {{ $t("tks.tksCalculatingResult") }}
      <Button
        @click="createPdf"
        v-if="!creatingPdf"
        variant="danger"
        size="sm"
        class="u-margin-left-small-sm-up u-margin-top-sm-down"
      >
        <i class="icofont-print"></i> {{ $t("common.printCalculation") }}
      </Button>
      <router-link
        v-if="!creatingPdf"
        :to="{ name: 'cycles-selection' }"
        class="u-display-inline-block u-margin-top-sm-down"
      >
        <Button block variant="primary" class="u-margin-left-small">
          {{ $t("cycles.selection2") }}
        </Button>
      </router-link>
    </h4>
    <hr />
    <no-auth v-if="!hasAuthorize.getById"></no-auth>
    <div class="row" v-else>
      <div
        class="es-xs-12 es-md-6"
        :class="{ ' es-lg-4': !creatingPdf, 'es-lg-6': creatingPdf }"
      >
        <ul class="c-list">
          <li class="c-list__item">
            {{ $t("tks.grainNames") }}
            <span>
              {{ item.selectedCerealType }}
            </span>
          </li>
          <li class="c-list__item">
            {{ $t("tks.deviceNames") }}
            <span>
              {{ item.deviceName }}
            </span>
          </li>
          <li class="c-list__item">
            {{ $t("tks.airInitialTemperature") }}
            <span> {{ item.airInitialTemperature }} °C </span>
          </li>
          <li class="c-list__item">
            {{ $t("tks.airInitialHumidity") }}
            <span> {{ item.airInitialHumidity }} % </span>
          </li>
          <li class="c-list__item">
            {{ $t("tks.airFinalTemperature") }}
            <span> {{ item.airFinalTemperature }} °C </span>
          </li>
          <li class="c-list__item">
            {{ $t("tks.airFinalHumidity") }}
            <span> {{ item.airFinalHumidity }} % </span>
          </li>
          <li class="c-list__item">
            {{ $t("tks.siloHeight") }}
            <span> {{ item.siloHeight }} m </span>
          </li>
          <li class="c-list__item">
            {{ $t("tks.grainWeight") }}
            <span> {{ item.grainWeight }} TON </span>
          </li>
        </ul>
        <h6 class="u-margin-top-small">{{ $t("tks.pressureLoss") }}</h6>
        <ul class="c-list">
          <li class="c-list__item">
            {{ $t("tks.silo") }}
            <span> {{ item.silo }} </span>
          </li>
          <li class="c-list__item">
            {{ $t("tks.channel") }}
            <span> 200 Pa</span>
          </li>
          <li class="c-list__item">
            {{ $t("tks.intoDevice") }}
            <span> 800 Pa </span>
          </li>
          <li class="c-list__item">
            {{ $t("tks.total") }}
            <span> {{ item.total }} </span>
          </li>
        </ul>
      </div>
      <div
        v-if="!creatingPdf"
        class="es-xs-12 es-md-6 u-text-align-center"
        :class="{ 'es-lg-4': !creatingPdf, 'es-lg-6': creatingPdf }"
      >
        <img src="@/assets/images/tksImage.png" alt="tks" />
      </div>
      <div
        class="es-xs-12 es-md-6"
        :class="{
          ' es-lg-4': !creatingPdf,
          'es-lg-6': creatingPdf,
        }"
      >
        <ul class="c-list">
          <li class="c-list__item">
            {{ $t("tks.coolingDuration") }}
            <span>
              {{ item.hour }} {{ $t("tks.hour") }} -
              <span> {{ item.day }} {{ $t("tks.day") }} </span></span
            >
          </li>
          <li class="c-list__item">
            {{ $t("tks.connectionDimensions") }}
            <span> {{ item.connectionDimensions }} m </span>
          </li>
          <li class="c-list__item">
            {{ $t("tks.maximumFanAirFlowRate") }}
            <span> {{ item.maximumFanAirFlowRate }} m³/h </span>
          </li>
          <li class="c-list__item">
            {{ $t("tks.maximumFanPressure") }}
            <!-- <span> {{ item.maximumFanPressure }} Pa </span> -->
            <span>6000 Pa </span>
          </li>
          <li class="c-list__item">
            {{ $t("tks.electricalData") }}
            <span>
              {{ item.electricalData }}
            </span>
          </li>
          <li class="c-list__item">
            {{ $t("tks.operatingCurrent") }}
            <span> {{ item.operatingCurrent }} A </span>
          </li>
          <li class="c-list__item">
            {{ $t("tks.maximumOperatingCurrent") }}
            <span> {{ item.maximumOperatingCurrent }} A </span>
          </li>
          <li class="c-list__item">
            {{ $t("tks.operatingPowerConsumption") }}
            <span> {{ item.operatingPowerConsumption }} kW </span>
          </li>
          <li class="c-list__item">
            {{ $t("tks.fanFlowRate") }}
            <span> {{ item.fanFlowRate }} m³/h </span>
          </li>
          <li class="c-list__item">
            {{ $t("tks.capacity") }}
            <span> {{ item.capacity }} kW</span>
          </li>
          <li class="c-list__item">
            {{ $t("common.createdDate") }}
            <span>
              {{ $date.format(item.createdDate) }}
            </span>
          </li>
        </ul>
      </div>
      <div
        v-if="creatingPdf"
        class="es-xs-12 es-md-6 u-text-align-center u-margin-top"
        :class="{ 'es-lg-4': !creatingPdf, 'es-lg-12': creatingPdf }"
      >
        <img src="@/assets/images/tksImage.png" alt="tks" />
      </div>
    </div>
  </div>
</template>

<script>
import Requests from "@/services/Requests";
import Button from "@/components/Base/Button.vue";
import html2pdf from "html2pdf.js";
import authorize from "./authorize";

export default {
  mixins: [authorize],
  components: {
    Button,
  },
  data() {
    return {
      creatingPdf: false,
      isLoading: true,
      item: {},
    };
  },
  methods: {
    async createPdfBlob() {
      const element = document.getElementById("tks-calculating-result");
      const opt = {
        margin: [25, 1, 40, 1],
        filename: "tks-calculating-result.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
      };

      const footerImg = "/pdf-footer.png";
      const headerImg = "/pdf-header.png";
      //const footerLogo = ;
      html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          var totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            // set footer to every page
            pdf.setPage(i);
            // set footer font
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            pdf.addImage(
              footerImg,
              "png",
              10,
              pdf.internal.pageSize.getHeight() - 30,
              pdf.internal.pageSize.getWidth() - 20,
              30
            );
            pdf.addImage(
              headerImg,
              "png",
              10,
              0,
              pdf.internal.pageSize.getWidth() - 20,
              25
            );
            // pdf.addImage(
            //   footerLogo,
            //   "png",
            //   0,
            //   0,
            //   pdf.internal.pageSize.getWidth(),
            //   0.3
            // );
          }
          window.open(pdf.output("bloburl"), "_blank");
          this.$store.dispatch("SET_ACTION_MODAL", {
            isLoading: false,
            status: false,
          });
          this.creatingPdf = false;
          this.$emit("pdfCreated");
        });
      return "";
    },
    blobToFile(blob, fileName) {
      return new File([blob], fileName, { type: "application/pdf" });
    },
    async createPdf() {
      this.creatingPdf = true;
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: true,
        status: true,
        message: this.$t("common.creatingPdf"),
        duration: 20 * 60 * 1000,
      });
      setTimeout(async () => {
        await this.createPdfBlob();
      }, 500);
    },
    async getItem() {
      this.isLoading = true;
      const response = await Requests.Tks.GetById({
        params: {
          id: this.$route.params.id,
        },
      });
      if (response.message === "OK") {
        this.item = response.data;
      }
      this.isLoading = false;
    },
  },
  mounted() {
    this.getItem();
  },
};
</script>

<style></style>
